import { findSelectOption } from "../../../../libs/utils";
import { calculateRentFree, calculateYears, dateFormat, filterDropdownValue } from "../utils";

export const getDefaultValues = (
  bookingDetails,
  bookingForm,
  lease_nature,
  landlordUsers,
  initialBookingStartDate,
  initialBookingEndDate,
  initialLeaseStartDate,
  initialLeaseEndDate,
  yearsOptions,
  initialMoveInDate,
  rentFreePeriodOptions,
) => ({
  leaseNature: filterDropdownValue(bookingForm?.leaseTerms?.leaseNature, lease_nature),
  leaseManager: filterDropdownValue(bookingForm?.leaseManager?.userId || bookingForm?.leaseManager, landlordUsers),
  externalAgent: bookingForm?.externalAgent || "",
  numberOfOcupants: bookingDetails?.tenantDetails?.numberOfOcupants || 1,
  bookingStartDate: initialBookingStartDate,
  bookingEndDate: initialBookingEndDate,
  fitOutStartDate: dateFormat(bookingForm?.leaseTerms?.fitOutStartDate),
  fitOutEndDate: dateFormat(bookingForm?.leaseTerms?.fitOutEndDate),
  leaseStartDate: initialLeaseStartDate,
  leaseEndDate: initialLeaseEndDate,
  numberOfYears:
    findSelectOption(yearsOptions, bookingDetails?.leaseTerms?.numberOfYears) ??
    calculateYears(bookingDetails?.leaseTerms?.leaseStartDate, bookingDetails?.leaseTerms?.leaseEndDate) ??
    yearsOptions[0],
  rentFreePeriod:
    findSelectOption(rentFreePeriodOptions, bookingForm?.leaseTerms?.rentFreePeriod) ??
    calculateRentFree(bookingForm?.leaseTerms?.rentFreeStartDate, bookingForm?.leaseTerms?.rentFreeEndDate) ??
    rentFreePeriodOptions[0],
  moveInDate: initialMoveInDate,
  noOfFreeParkingSlots: bookingForm?.leaseTerms?.noOfFreeParkingSlots,
});
